import { render, staticRenderFns } from "./AdminOrganization.vue?vue&type=template&id=2897c6bb&scoped=true"
import script from "./AdminOrganization.vue?vue&type=script&lang=ts"
export * from "./AdminOrganization.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2897c6bb",
  null
  
)

export default component.exports